import moment from 'moment';

export const isAttachedToLongTermScheduleCrew = ({
    longTermSchedules,
    ltsCrews,
    weekdays,
    dayValue,
    employeeId,
    equipmentId,
}) =>
    longTermSchedules.some((lts) => {
        let crew = ltsCrews.find((c) => c.id == lts.crewId);

        if (lts.publishedCrew) {
            crew = lts.publishedCrew;
        }

        if (!crew) {
            return false;
        }

        if (
            Boolean(employeeId) &&
            !crew.crewEmployeeMemberships.includes(employeeId)
        ) {
            return false;
        }

        if (
            Boolean(equipmentId) &&
            !crew.crewEquipmentMemberships.includes(equipmentId)
        ) {
            return false;
        }

        return weekdays.some(
            (d) =>
                lts.workDays.some(
                    (wd) =>
                        moment(d).isSame(wd, 'day') &&
                        moment(wd).day() == dayValue &&
                        moment(d).day() == dayValue
                ) &&
                // reserve employees that are part of crews until
                // the day's order is released; after that, defer
                // to whatever assignments are/not made
                !lts.releasedDays.some(
                    (rd) =>
                        moment(d).isSame(rd, 'day') &&
                        moment(rd).day() == dayValue &&
                        moment(d).day() == dayValue
                )
        );
    });
